import { render } from "./admin_retailer_add_wallet.vue?vue&type=template&id=38c75840"
import script from "./admin_retailer_add_wallet.vue?vue&type=script&lang=js"
export * from "./admin_retailer_add_wallet.vue?vue&type=script&lang=js"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__